<h4 mat-dialog-title>
  Advanced Filters — {{ source | uppercase }}
</h4>

<mat-dialog-content class="content">

  <div *ngFor="let filter of filters; let i = index" class="filter-row">

    <!-- Field -->
    <mat-form-field appearance="outline" class="field">

      <mat-label>Field</mat-label>

      <mat-select [(ngModel)]="filter.field">

        <mat-option
          *ngFor="let field of datasetFields"
          [value]="field">

          {{ field }}

        </mat-option>

      </mat-select>

    </mat-form-field>


    <!-- Operator -->
    <mat-form-field appearance="outline" class="operator">

      <mat-label>Operator</mat-label>

      <mat-select [(ngModel)]="filter.operator">

        <mat-option
          *ngFor="let op of operators"
          [value]="op.value">

          {{ op.label }}

        </mat-option>

      </mat-select>

    </mat-form-field>


    <!-- Value -->
    <mat-form-field appearance="outline" class="value">

      <mat-label>Value</mat-label>

      <input
        matInput
        [(ngModel)]="filter.value">

    </mat-form-field>


    <!-- Remove -->
    <button
      mat-icon-button
      color="warn"
      (click)="removeFilter(i)"
      *ngIf="filters.length > 1">

      <mat-icon>delete</mat-icon>

    </button>

  </div>


  <!-- Add button -->
  <button
    mat-stroked-button
    color="primary"
    (click)="addFilter()">

    + Add Filter

  </button>

</mat-dialog-content>


<mat-dialog-actions align="end">
<div class="action-buttons">
   <app-common-button
  label="Cancel"
  title="Cancel"
  [buttonId]="1111"
  variant="cancel"
  width="110px"
  (clicked)="cancel()">
</app-common-button>

   <app-common-button
  label="Apply Filters"
  title="Apply Filters"
  [buttonId]="1111"
  variant="primary"
  width="110px"
  (clicked)="applyFilters()">
</app-common-button>
</div>
</mat-dialog-actions>
